<template>
   
       <div >
            <a :title="buttonTitle" 
             :class="$root.remote_connectionsStates[pc.id] ? 'bg-remote' : 'fg-black bg-gray'" class="button dropdown-toggle">
                <!--span :class="$root.remote_connectionsStates[pc.id] ? 'icon mif-2x mif-cast-connected' : 'icon mif-2x mif-cast'"></span-->
                <!--<span  :class="wait ? 'mif-spinner3 ani-spin' : $root.remote_connectionsStates[pc.id] ? 'icon mif-2x mif-cast-connected' : 'icon mif-2x mif-cast'"></span>-->
                <img :src="$root.remote_connectionsStates[pc.id] ? '/assets/img/icons/remote-access2-white.png' : '/assets/img/icons/remote-access2.png'" style="width:22px; height:22px; min-width:22px; min-height:22px;" alt="Iperius Remote">    

                <div class="text-left fg-white" v-if="complete == 'true'">
                    {{ $t("Remote Access") }}
                </div>
            </a>
            <ul class="d-menu border place-right text-left mt-2" data-role="dropdown">
                <!--MENU SE REMOTE è ATTIVO-->
                <template v-if="$root.remote_connectionsStates[pc.id]">
                    <li  class="text-bold">
                        <a @click="connect" data-role="hint" data-hint-position="left" data-cls-hint="fg-white bg-remote" :data-hint-text="$t('The Iperius Remote client will launch and initiate a remote session to the host.', { 0: pc.id_remote.replace(/(\d{3})(?=\d)/g, '$1 ') })" 
                            :class="$root.remote_connectionsStates[pc.id] ? 'secondary' : 'fg-gray disabled'">
                            <!--span class="icon mif-2x mif-screen_share"></span>{{ $t("Connect to {0}", { 0: pc.id_remote.replace(/(\d{3})(?=\d)/g, '$1 ') }) }} screencast-svgrepo-com -->
                            <img src="/assets/img/icons/screencast-bold.svg"></img>{{ $t("Connect to {0}", { 0: pc.id_remote.replace(/(\d{3})(?=\d)/g, '$1 ') }) }}
                        </a>
                    </li> 
                    <!--li>
                        <a @click="restartIR4(pc)" :data-tip="$t('The Iperius Remote client will restart on the remote host.')" :class="$root.remote_connectionsStates[pc.id] ? 'fg-dark' : 'fg-gray disabled'" >                                  
                            <img src="/assets/img/icons/reboot.svg"></img>{{ $t("Restart the remote client") }}             
                        </a>
                    </li-->
                    <li v-if="pc.service_remote === true">
                        <a @click="unistallserviceIR4(pc)" data-role="hint" data-hint-position="left" data-cls-hint="fg-black bg-white" :data-hint-text="$t('The Iperius Remote client will be removed from services and the unattended mode will be disabled.')" :class="$root.remote_connectionsStates[pc.id] ? 'fg-dark' : 'fg-gray disabled'" >
                            <img src="/assets/img/icons/uninstall_service.svg"></img>{{ $t("Disable unattended mode") }}             
                        </a>
                    </li>
                    <li>
                        <a @click="closeIR4(pc)" data-role="hint" data-hint-position="left" data-cls-hint="fg-black bg-white" :data-hint-text="$t('The Iperius Remote client will close on the remote host.')" :class="$root.remote_connectionsStates[pc.id] ? 'fg-dark' : 'fg-gray disabled'" >
                            <!--span class="icon mif-2x mif-cancel mr-2"></span><span>{{ $t("Terminate the remote client") }}</span> close-lg-svgrepo-com-->
                            <img src="/assets/img/icons/stop-circle.svg"></img>{{ $t("Terminate the remote client") }}
                        </a>
                    </li>
                    <li v-if="pc.version_remote < $session.getLastRemoteVersion()">
                        <a @click="updateIR4(pc)" data-role="hint" data-hint-position="left" data-cls-hint="fg-black bg-white" :data-hint-text="$t('The Iperius Remote client will update on the remote host.')" :class="$root.remote_connectionsStates[pc.id] ? 'fg-dark' : 'fg-gray disabled'" >
                            <!--span class="icon mif-2x mif-refresh"></span> {{ $t("Update the remote client") }}-->
                            <img src="/assets/img/icons/update-arrow.svg"></img>{{ $t("Update the remote client") }}
                        </a>
                    </li>
                    <li v-if="pc.remote_license_status == 1" class="divider"></li>
                    <li v-if="pc.remote_license_status == 1">
                        <a href="#"
                            :class="{ disabled: isDeleting, 'fg-dark': !isDeleting, 'fg-gray': isDeleting }"
                            :title="isDeleting
                                ? $t('Delete in progress')
                                : $t('Remove the Iperius Remote client from the address book associated with your license.')"
                            :style="isDeleting ? 'pointer-events:none;opacity:.5;' : ''"
                            @click.prevent="!isDeleting && openStartDialogDelete()">
                            <span class="mif mif-storage-remove icon"></span>{{ $t('Remove this device from the Iperius Remote address book') }}
                        </a>
                    </li>
                </template>
                
                <!--MENU SE REMOTE NON E' ATTIVO MA E' ATTIVA LA LICENZA DI ONE-->

                <li v-else-if="pc.backup_license_status !== 0 && $root.connectionsStates[pc.id]">
                    <a 
                        @click="downloadandRunIR4(pc)" 
                        data-role="hint" data-hint-position="bottom" data-cls-hint="fg-black bg-white"
                        :data-hint-text="$t('The Iperius Remote client will be started on the remote host (automatically downloads if needed)')" 
                        class="fg-dark">
                        <!--span class="icon mif-2x mif-cast-connected"></span> {{ $t("Enable remote connection") }}-->
                        <img src="/assets/img/icons/screencast-fill.svg"></img>{{ $t("Enable remote connection") }}
                    </a>
                </li>

                <li v-else-if="pc.backup_license_status !== 0 && !$root.connectionsStates[pc.id]" class="text-center p-4 no-wrap">
                    <span class="mif-info fg-gray mif-3x mb-2"></span>
                    <span class="d-block">
                        {{ $t("To start Iperius Remote, the computer must be turned on and Iperius One must be running.") }}
                    </span>                    
                    <!--a v-if="isComputerLicensed" onclick="window.Metro.charms.toggle('#agentbuilding');" class="fg-primary text-bold mt-2" target="_blank">
 
                    </a>
                    <router-link v-else class="ml-1" :to="'/licenses'" style="cursor:pointer;">
                    </router-link-->
                </li>
                
                <!--MENU SE REMOTE NON E' ATTIVO E NONE' ATTIVA LA LICENZA DI ONE-->

                <li v-else class="text-center p-4 no-wrap">
                    <span class="mif-lock fg-red mif-2x mb-2"></span>
                    <span class="d-block">
                        {{ $t("To automatically install and start Iperius Remote on this device, the Iperius One Agent must be installed first.") }}
                    </span>                    
                    <a v-if="isComputerLicensed()" onclick="window.Metro.charms.toggle('#agentbuilding');" class="fg-primary text-bold mt-2" target="_blank">
                        {{ $t("Install and activate the Iperius One Agent on this computer") }}
                    </a>
                    <router-link v-else class="ml-1 text-bold" :to="'/licenses'" style="cursor:pointer;">
                        {{ $t("Get your Iperius One license to activate this feature") }}
                    </router-link>
                </li>
                
            </ul> 
        </div>       
</template>
<script>

import { waitSeconds } from '../../utils/utilitiesmodule';
import { PC_MESSAGES } from '../../utils/messages';

export default {
    name: "PCRemoteLink",
    props: {
        complete: {
            type: String,
        },
        pc: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            wait: false,
            isDeleting: false,
        }
    },
    computed: {
        buttonTitle() {

            // se IperiusOne è connesso
            if (this.$root.connectionsStates[this.pc.id]) {
                if (this.$root.remote_connectionsStates[this.pc.id]) {
                    return 'Iperius Remote ' + this.pc.version_remote + "\n" + this.$t('Open a Remote connection');
                }

                return this.$t('Iperius Remote not running or not installed') + '\n' + this.$t('Start Iperius Remote (automatically downloads if needed)');
            }



            return; //this.$t('Iperius One not running or not installed.')

        }
    },
    beforeDestroy() {
        delete this.$root.remote_map_idPC_idRemote[this.pc.id];
        this.$root.checkRemoteConnectionTimerLight();
    },
    created() {

        if (this.$root.remote_connectionsStates[this.pc.id] == undefined) {
            this.$root.remote_connectionsStates[this.pc.id] = false;
        }

        if (this.$root.remote_map_idPC_idRemote[this.pc.id] == undefined) {
            this.$root.remote_map_idPC_idRemote[this.pc.id] = this.pc.id_remote;
            this.$root.checkRemoteConnectionTimerLight();
        }

    },
    methods: {

        openStartDialogDelete() {
            const dialogID = Math.floor(100000 + Math.random() * 900000).toString();
            const content = `
                <div class="mb-3 ml-1 d-flex flex-align-center">
                    ${this.$t('Are you sure you want to remove this Iperius Remote client from the address book associated with your license?')}
                </div>
            `;

            this.$root.$on(dialogID, async ok => {
                try {
                    if (!ok) return;

                    this.isDeleting = true;
                    const response = await this.$api.deleteComputerFromAddressBook(this.pc.id, false);
                    if (response != null) {
                        this.pc.remote_license_status = 0;
                        this.$root.toast(this.$t(PC_MESSAGES.REMOVE_FROM_ADDRESSBOOK), "success");
                    }
                } finally {
                    this.isDeleting = false;
                    this.$root.$off(dialogID);
                }
            });

            const title = `
                <div class="d-flex flex-align-center">
                    <svg width="32" height="32" viewBox="0 0 24 24"
                        class="mr-2 mt-2"
                        style="vertical-align:bottom; flex-shrink:0;"
                        aria-hidden="true">
                        <path fill="#001affff"
                            d="M10 1.5c-.33 0-.64.17-.82.45l-8 13A.94.94 0 0 0 1.94 16h16.12a.94.94 0 0 0 .76-1.05l-8-13A.95.95 0 0 0 10 1.5zM10 6c.28 0 .5.22.5.5v4a.5.5 0 0 1-1 0v-4c0-.28.22-.5.5-.5zm0 7a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"/>
                    </svg>
                    <span class="ml-1 m-0">${this.$t('Confirm deletion from address book')}</span>
                </div>
            `;

            this.$root.openYesNoDialog(dialogID, title, content, this.$t('Delete'), this.$t('Close'), 'js-dialog-close secondary', 'js-dialog-close button');
        },

        async connect() {
            if (this.wait) return;

            const hasCustomPassword = ![null, ''].includes(this.pc.custom_password);
            if (!hasCustomPassword) {
                await this.startRemoteConnection();
                return;
            }

            this.$root.$emit('OPENIRCONNECTION', {
                id_remote: this.pc.id_remote,
                custom_password: this.pc.custom_password,
                onConfirmed: () => this.startRemoteConnection()
            });
        },

        async startRemoteConnection() {
            if (this.wait) return;

            this.wait = true;
            try {
                const keyOTP = await this.$api.getOTP(this.pc.id);
                if (keyOTP == null) {
                    this.$root.toast(this.$t("The remote computer does not belong to the groups managed by the logged-in user."), "alert");
                    return;
                }

                const link = document.createElement('a');
                link.href = `iperiusremote://${keyOTP}/`;
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } finally {
                this.wait = false;
            }
        },
        async updateIR4(pc) {

            let self = this;

            self.wait = true;

            // [20-11-2024] l'update di un client iperius remote avviene con chiamata alle api come per l'area admin di remote
            // il socket invierà poi il command di update al client tramite socket
            await this.$api.updateIperiusRemote4(pc.id_remote).then(async response => {
                if (response != null && response.status == 200) {

                    this.$root.toast(this.$t('Update command sent successfully.'), "success");

                    //await waitSeconds(3); // diamo il tempo ad iperius remote di riavviarsi

                };
                self.wait = false;
            });
        },

        /*async restartIR4(pc) {

            let self=this;

            self.wait=true;

            // [20-11-2024] il restart di un client iperius remote avviene con chiamata alle api come per l'area admin di remote
            // il socket invierà poi il command di restart al client tramite socket
            await this.$api.restartIperiusRemote4(pc.id_remote).then(async response => {
                if (response!=null && response.status==200) {

                    this.$root.toast(this.$t('Restart command sent successfully.'), "success");

                    await waitSeconds(3); // diamo il tempo ad iperius remote di riavviarsi

                };
                self.wait=false;
            });
        }, */

        async unistallserviceIR4(pc) {

            let self = this;

            self.wait = true;

            // [20-11-2024] il restart di un client iperius remote avviene con chiamata alle api come per l'area admin di remote
            // il socket invierà poi il command di restart al client tramite socket
            await this.$api.unistallIperiusRemote4(pc.id_remote).then(async response => {
                if (response != null && response.status == 200) {

                    this.$root.toast(this.$t('Disable unattended mode command sent successfully.'), "success");

                    await waitSeconds(3); // diamo il tempo ad iperius remote di riavviarsi

                };
                self.wait = false;
            });
        },

        async closeIR4(pc) {

            let self = this;

            self.wait = true;

            // [20-11-2024] il close di un client iperius remote avviene con chiamata alle api come per l'area admin di remote
            // Elixir invierà poi il command di close al client tramite socket
            await this.$api.closeIperiusRemote4(pc.id_remote).then(async response => {
                if (response != null && response.status == 200) {

                    this.$root.toast(this.$t('Terminate command sent successfully.'), "success");

                };

                self.wait = false;
            });
        },

        async downloadandRunIR4(pc) {

            let self = this;

            this.wait = true;

            this.$root.socket("SETPC", this.pc.id) // non essendo "dentro" la gestione di un singolo pc ma sulla lista dei computer devo settare l'id del computer
                .then(() => {
                    return this.$root.socket("DOWNLOADREMOTE", pc.id); // chiamo il metodo per il download
                })
                .then(async response => {
                    if (response == true) {

                    }
                    this.wait = false;
                    //this.$root.toast(this.$t("The download of Iperius Remote on the remote host has started successfully. Please wait a few minutes for Iperius Remote to come online."), "success");
                })
                .catch(error => {
                    self.$root.toast(this.$t("An error occurred:"), error);
                    this.wait = false;
                });

        },

        isComputerLicensed: function () {
            const licenses = this.$session.getLicenses();

            // Se manca qualcosa, esco subito
            if (!licenses || !this.pc.id) return false;

            const checkLicenseCategory = (licenseCategory) => {
                const licensesArray = licenses[licenseCategory] || [];

                for (let i = 0; i < licensesArray.length; i++) {
                    const license = licensesArray[i];
                    const computers = license.computers || [];

                    for (let j = 0; j < computers.length; j++) {
                        if (computers[j].id === this.pc.id) {
                            return true; // Early exit non appena trova
                        }
                    }
                }

                return false;
            };

            // Controllo sia backup che monitoring
            return checkLicenseCategory('backup') || checkLicenseCategory('monitoring');
        }
    }

}
</script>
